export default __webpack_public_path__ + "static/media/offers.7d8f5b4b.svg";